import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=97d23c48&"
import script from "./CityList.vue?vue&type=script&lang=ts&"
export * from "./CityList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports